/**
 * 受験者登録ページ
 *************************************************/
import Footer from 'components/common/Footer';
import React, { FC } from 'react';
import { Container } from 'semantic-ui-react';

import Header from '../common/Header';

const RegistUserPage: FC = () => {
  return (
    <>
      <Header />
      <Container style={{ marginBottom: '70px' }}>現在工事中</Container>
      <Footer />
    </>
  );
};
export default RegistUserPage;
